export default __webpack_public_path__ + "1_login_pl.png";